// extracted by mini-css-extract-plugin
module.exports = {"container":"collapse__container___3xR_W","is-animating":"collapse__is-animating___1SnXV","is-collapsed":"collapse__is-collapsed___EDHWV"};